import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {
  StyledContainer,
  StyledVideoButton,
  StyledSocial,
  StyledTitle,
  StyledLength,
  StyledPlay,
} from './VideoSlider.styles';
import { Icon } from '../common/Icons';
import IframePopUp from '../IframePopUp/IframePopUp';
import { useModalContext } from '../../core/context/ModalContext';
import useScreenSize from '../../core/hooks/useScreenSize';

function VideoSlider({ data }) {
  const [source, setSource] = useState('');
  const [provider, setProvider] = useState('');
  const [size] = useScreenSize();
  const { createModal } = useModalContext();

  const { element: IframeModal, close, open } = useMemo(() => createModal(false), [createModal]);

  const closeModal = useCallback(() => {
    close();
  }, [close]);

  const onClick = useCallback(
    (videoSource, videoProvider) => {
      if (!videoSource) return;

      setSource(videoSource);
      setProvider(videoProvider);
      open();
    },
    [open]
  );

  const desktopWidth = useMemo(() => size > 991, [size]);

  if (!data.length) return null;

  return (
    <>
      <StyledContainer>
        <Swiper
          spaceBetween={desktopWidth ? 27 : 10}
          slidesPerView="auto"
          slidesOffsetBefore={desktopWidth ? 0 : 26}
          slidesOffsetAfter={desktopWidth ? 0 : 26}
          direction={desktopWidth ? 'vertical' : 'horizontal'}
        >
          {data.map(video => (
            <SwiperSlide key={video.id}>
              {video.video.src && video.video.provider && (
                <StyledVideoButton
                  bgimage={video.image.src || ''}
                  onClick={() => onClick(video.video.src, video.video.provider)}
                >
                  {video.social && (
                    <StyledSocial>
                      {video.social === 'tedtalk' && <Icon.Tedtalk aria-hidden />}
                      {video.social === 'yt' && <Icon.Youtube aria-hidden />}
                    </StyledSocial>
                  )}
                  {video.title && <StyledTitle>{video.title}</StyledTitle>}
                  {video.length && (
                    <StyledLength>
                      {video.length}
                      {video.length > 1 ? ' mins' : ' min'}
                    </StyledLength>
                  )}
                  <StyledPlay>
                    <Icon.ArrowSolid aria-hidden />
                  </StyledPlay>
                </StyledVideoButton>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </StyledContainer>

      <IframeModal>
        <IframePopUp source={source} provider={provider} onClose={closeModal} />
      </IframeModal>
    </>
  );
}

VideoSlider.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
      }),
      social: PropTypes.string,
      title: PropTypes.string,
      length: PropTypes.string,
      video: PropTypes.shape({
        src: PropTypes.string,
        provider: PropTypes.string,
        title: PropTypes.string,
        thumbnail: PropTypes.string,
      }),
    })
  ),
};

VideoSlider.defaultProps = {
  data: [],
};

export default VideoSlider;
